var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["ValueCache"]: () => __WEBPACK_EXTERNAL_MODULE__leverege_value_cache_d85394ca__.ValueCache, ["ValuesCache"]: () => __WEBPACK_EXTERNAL_MODULE__leverege_value_cache_d85394ca__.ValuesCache });